import { AgmCoreModule } from '@agm/core';
import { AgmJsMarkerClustererModule } from '@agm/js-marker-clusterer';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgbActiveModal, NgbDatepickerModule, NgbDropdownModule, NgbPaginationModule, NgbTimepickerModule, NgbTooltipModule, NgbTypeaheadModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { NgChatModule } from 'ng-chat';
import { ClickOutsideModule } from 'ng4-click-outside';
import { Ng5SliderModule } from 'ng5-slider';
import { NgxCleaveDirectiveModule } from 'ngx-cleave-directive';
import { CustomFormsModule } from 'ngx-custom-validators';
import { DndModule } from 'ngx-drag-drop';
import { MomentModule } from 'ngx-moment';
import { OrvComponentsModule, PipesModule, RoundPipe } from 'orv-ui-base-lib';

import { WebDataRocksPivot } from '../../webdatarocks/webdatarocks.angular4';
import { AclDirective } from './acl/acl.directive';
import { AssignToModalComponent } from './assign-to-modal/assign-to-modal.component';
import { AttachmentImageModalComponent } from './attachment-image-modal/attachment-image-modal.component';
import { AttachmentUploadComponent } from './attachments/attachment-upload/attachment-upload.component';
import { AttachmentsComponent } from './attachments/attachments.component';
import { BarChartComponent } from './bar-chart/bar-chart.component';
import { ChatComponent } from './chat/chat.component';
import { OrvChatAdapter } from './chat/orv-chat-adapter';
import { ClusteredChartComponent } from './clustered-chart/clustered-chart.component';
import { CommercialDirective } from './commercial/commercial.directive';
import { ConfsComponent } from './confs/confs.component';
import { CustomMultiSelectComponent } from './custom-multi-select/custom-multi-select.component';
import { DepoMultiSelectComponent } from './depo-multi-select/depo-multi-select.component';
import { DispatchMapComponent } from './dispatch-map/dispatch-map.component';
import { DraggableCardComponent } from './draggable-cards/draggable-card/draggable-card.component';
import { DraggableCardsComponent } from './draggable-cards/draggable-cards.component';
import { EmailViewerComponent } from './email-viewer/email-viewer.component';
import { EventCardComponent } from './event-card/event-card.component';
import { GaugeChartComponent } from './gauge-chart/gauge-chart.component';
import { HeartbitPointComponent } from './heartbit-point/heartbit-point.component';
import { InfoPanelComponent } from './info-panel/info-panel.component';
import { InputLoadingComponent } from './input-loading/input-loading.component';
import { IosToggleComponent } from './ios-toggle/ios-toggle.component';
import { ListFiltersComponent } from './list-filters/list-filters.component';
import { ColumnComponent } from './move-columns/column/column.component';
import { MoveColumnsComponent } from './move-columns/move-columns.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { PieChartComponent } from './pie-chart/pie-chart.component';
import { RouteManagerResponsiveComponent } from './route-manager-responsive/route-manager-responsive.component';
import { RouteManagerComponent } from './route-manager/route-manager.component';
import { AddTaskComponent } from './route-planner/add-task/add-task.component';
import { KpitableComponent } from './route-planner/kpitable/kpitable.component';
import { RoutePlannerComponent } from './route-planner/route-planner.component';
import { StackedColumnChartComponent } from './stacked-column-chart/stacked-column-chart.component';
import { TripActionsLogModalComponent } from './trip-actions-log-modal/trip-actions-log-modal.component';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		AgmCoreModule,
		AgmJsMarkerClustererModule,
		NgxDatatableModule,
		NgbTooltipModule,
		DndModule,
		NgbPaginationModule,
		NgbTypeaheadModule,
		NgbDropdownModule,
		NgbDatepickerModule,
		NgbTimepickerModule,
		NgxCleaveDirectiveModule,
		CustomFormsModule,
		ClickOutsideModule,
		TranslateModule,
		RouterModule,
		PipesModule,
		NgChatModule,
		Ng5SliderModule,
		MomentModule,
		OrvComponentsModule
	],
	exports: [
		InfoPanelComponent,
		ConfsComponent,
		MoveColumnsComponent,
		AclDirective,
		CommercialDirective,
		HeartbitPointComponent,
		RoundPipe,
		AttachmentsComponent,
		ListFiltersComponent,
		RoutePlannerComponent,
		RouteManagerComponent,
		DraggableCardComponent,
		DraggableCardsComponent,
		ChatComponent,
		PipesModule,
		AttachmentImageModalComponent,
		WebDataRocksPivot,
		AssignToModalComponent,
		EventCardComponent,
		NotFoundComponent,
		PieChartComponent,
		BarChartComponent,
		GaugeChartComponent,
		ClusteredChartComponent,
		StackedColumnChartComponent,
		DepoMultiSelectComponent,
		CustomMultiSelectComponent,
		OrvComponentsModule,
		AttachmentUploadComponent,
		DispatchMapComponent,
		TripActionsLogModalComponent,
		RouteManagerResponsiveComponent,
		InputLoadingComponent,
	],
	declarations: [
		InfoPanelComponent,
		ConfsComponent,
		MoveColumnsComponent,
		ColumnComponent,
		AclDirective,
		CommercialDirective,
		HeartbitPointComponent,
		AttachmentsComponent,
		AttachmentUploadComponent,
		ListFiltersComponent,
		RoutePlannerComponent,
		RouteManagerComponent,
		DraggableCardComponent,
		DraggableCardsComponent,
		ChatComponent,
		KpitableComponent,
		AttachmentImageModalComponent,
		WebDataRocksPivot,
		AssignToModalComponent,
		EventCardComponent,
		NotFoundComponent,
		EmailViewerComponent,
		AddTaskComponent,
		RouteManagerComponent,
		PieChartComponent,
		BarChartComponent,
		GaugeChartComponent,
		ClusteredChartComponent,
		StackedColumnChartComponent,
		DepoMultiSelectComponent,
		CustomMultiSelectComponent,
		DispatchMapComponent,
		TripActionsLogModalComponent,
		RouteManagerResponsiveComponent,
		IosToggleComponent,
		InputLoadingComponent,
	],
	providers: [
		OrvChatAdapter,
		NgbActiveModal
	],
	entryComponents: [
		AttachmentUploadComponent,
		AttachmentImageModalComponent,
		AddTaskComponent,
		KpitableComponent,
		TripActionsLogModalComponent,
	]
})
export class CoreComponentsModule {
}
